export const identityTransition = ({ posthogUserId, appUserId }) => {
  const isStale = posthogUserId !== null && posthogUserId !== appUserId;
  const needsIdentify = appUserId !== null && appUserId !== posthogUserId;

  return [
    ...(isStale ? ["reset"] : []),
    ...(needsIdentify ? ["identify"] : []),
  ];
};
